import { Heading } from './Heading';
import { spacingClass } from '@/utils/spacing';

/**
 * @param {{ title?: string, subtitle?: string, items?: Array<{ image?: string, title: string, description: string, ctaLabel?: string, ctaHref?: string }>, spacing?: string, headingLevel?: number }} props
 */
export function FeatureGridBlock({ title, subtitle, items = [], spacing = 'normal', headingLevel = 2 }) {
  return (
    <section className={'px-6 md:px-16 ' + spacingClass(spacing)}>
      <div className="max-w-6xl mx-auto">
        {(title || subtitle) && (
          <div className="max-w-xl mb-14">
            {title && <Heading level={headingLevel} className="font-heading text-h1 font-light text-theme-text mb-4">{title}</Heading>}
            {subtitle && <p className="text-body-lg text-theme-text-muted leading-relaxed">{subtitle}</p>}
          </div>
        )}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {items.map((item, i) => (
            <div key={i}>
              {item.image ? (
                <img src={item.image} alt={item.imageAlt || item.title || ''} className="w-full aspect-[4/3] object-cover rounded-lg mb-5" loading="lazy" decoding="async" />
              ) : (
                <div className="w-9 h-9 rounded-lg bg-theme-bg-subtle mb-5" />
              )}
              <Heading level={headingLevel + 1} className="font-heading text-h3 font-normal text-theme-text mb-2">{item.title}</Heading>
              <p className="text-sm text-theme-text-muted leading-relaxed">{item.description}</p>
              {item.ctaLabel && (
                <a href={item.ctaHref || '#'} className="inline-flex items-center text-sm text-theme-accent mt-3">
                  {item.ctaLabel}
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
